export enum ScheduledReportScheduleTypeEnum {
	Daily = 0,
	OnWeekday = 10,
	OnDayOfMonth = 20
}